define(['angular'], function(angular) {

const moment = require('moment');
    /**
     * @class MarketService
     */
    function MarketService() {
        var self = this;
        var markets = [];

        self.initMarkets = function _initMarkets(orderForm) {
            markets = orderForm.marketTypes;
        };

        self.getMarkets = function getMarkets() {
            return markets;
        };

        self.getMarketLabelStyle = function getMarketLabelStyle(order) {
            if (order.marketType.code === null) {
                return '';
            }

            var tmp = markets.find(function(market) {
                return order.marketType.code === market.code;
            });

            if (typeof tmp !== 'undefined') {
                return tmp.cssClass;
            }
            else {
                return '';
            }
        };

        self.getMarketLabel = function getMarketLabel(order) {
            return order.marketType.label;
        };

        self.getActivitiesList = function getActivitiesList(marketCode) {
            var tmp = markets.find(function(marketObject) {
                return marketObject.code === marketCode;
            });

            if (typeof tmp !== 'undefined') {
                return tmp.activities;
            }
            else {
                return '';
            }
        };

        self.isBoulangerieMarket = function isBoulangerieMarket(order) {
            if (typeof order !== 'undefined' && typeof order.marketType !== 'undefined') {
                return order.marketType.code === 'BOULANGERIE';
            }
            else {
                return false;
            }
        };

        self.isTabacPresseMarket = function isTabacPresseMarket(order) {
            if (typeof order !== 'undefined' && typeof order.marketType !== 'undefined') {
                return order.marketType.code === 'TABACPRESSE';
            }
            else {
                return false;
            }
        };

        self.isLadditionMarket = function isLadditionMarket(order) {
            if (typeof order !== 'undefined' && typeof order.marketType !== 'undefined') {
                return order.marketType.code === 'LADDITION';
            }
            else {
                return false;
            }
        };

        self.isAutreMarket = function isAutreMarket(order) {
            if (typeof order !== 'undefined' && typeof order.marketType !== 'undefined') {
                return order.marketType.code === 'AUTRE';
            }
            else {
                return false;
            }
        };

        self.isFleuristeMarket = function isFleuristeMarket(order) {
            if (typeof order !== 'undefined' && typeof order.marketType !== 'undefined') {
                return order.marketType.code === 'FLEURISTE';
            }
            else {
                return false;
            }
        };

        self.getMarketByCode = function getMarketByCode(marketCode) {
            return markets.find(function(marketObject) {
                return marketObject.code === marketCode;
            });
        };

        /**
         * Check if an option exists in a market or not.
         * @param  {Object}  option      the whole option object. price attribute is used to find if the option belongs to this market or not.
         * @param marketCode
         * @return {Boolean}
         */
        self.isOptionInMarket = function isOptionInMarket(option, marketCode) {
            return (
                option.prices.map(function(price) {
                    return price.marketType.code;
                }) || []
            ).reduce(function(acc, curr) {
                return acc || curr === marketCode;
            }, false);
        };

        /**
         * Check if an option exists in a market or not.
         * @param item
         * @param contractCode
         * @param tillPrices
         * @param marketCode
         * @return {Boolean}
         */
        self.isTillInMarket = function (item, marketCode, contractCode, tillPrices ) {
            let res = [];
            tillPrices.reduce((curr, till) => {
                if(till.tillType.code === item.tillType.code && till.orderType.code === item.orderType.code)
                    curr.push(till);
                return curr;
            },[]).map(t => {
                t.prices.forEach(price => {
                    if(price.marketType.code === marketCode && price.type.code === contractCode )
                        res.push(price)
                })
            });
            return res.length > 0;
        };

        return self;
    }

    MarketService.$inject = [];

    angular.module('app.bdc.common.marketService', []).factory('marketService', MarketService);
});
